export class OverrideEnvironmentRequest {
    'environment';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "environment",
            "baseName": "environment",
            "type": "Environment",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideEnvironmentRequest.attributeTypeMap;
    }
    constructor() {
    }
}
